<template lang="html">
  <section class="position-fixed bg-light mobile-aside" id="sidebar">
    <div class="sidebar-menu">
      <div class="position-absolute close-btn">
        <span @click="hide" class="btn text-danger py-1 px-2 " type="button" name="button">
          <i class="fa fa-times" aria-hidden="true"></i>
        </span>
      </div>
      <ul class="mt-5">
        <li :class="$route.path === '/' ? 'active' : ''" @click="hide">
          <router-link class="h5" to="/"> HOME </router-link>
        </li>
        <li :class="$route.path === '/products' ? 'active' : ''" @click="hide">
          <router-link class="h5" to="/products"> SHOP </router-link>
        </li>
        <li v-if="isLoggedIn" :class="$route.path === '/wishlist' ? 'active' : ''" @click="hide">
          <router-link class="h5" to="/wishlist"> WISHLIST </router-link>
        </li>
        <li v-if="isLoggedIn" :class="$route.path === '/checkout' ? 'active' : ''" @click="hide">
          <router-link class="h5" to="/checkout"> CHECKOUT </router-link>
        </li>
        <li v-if="isLoggedIn" :class="$route.path === '/account' ? 'active' : ''" @click="hide">
          <router-link class="h5" to="/account"> ACCOUNT </router-link>
        </li>
        <hr>
        <li v-if="isLoggedIn" @click="hide">
          <span @click="logout" class="btn text-left text-danger">logout</span>
        </li>
        <li v-if="!isLoggedIn" :class="$route.path === '/signup' ? 'active' : ''" @click="hide">
          <router-link class="btn text-left" to="/signup">SIGNUP</router-link>
        </li>
        <li v-if="!isLoggedIn" :class="$route.path === '/login' ? 'active' : ''" @click="hide">
          <router-link class="btn text-left" to="/login">LOGIN</router-link>
        </li>
      </ul>
    </div>
  </section>
</template>

<script>
export default {
  data(){
    return{
      isLoggedIn: false
    }
  },
  mounted(){
    window.localStorage.getItem('care_user_auth_token') ? this.isLoggedIn = true : this.isLoggedIn = false
  },
  methods:{
    hide(){
      this.$emit('hideAside')
    },
    logout(){
      localStorage.removeItem('care_user_auth_token');
      localStorage.removeItem('care_user_id');
      localStorage.removeItem('care_user_name');
      this.$router.history.push('/login');
    }
  }
}
</script>

<style lang="css" scoped>
.mobile-aside{
  z-index: 999999999999999;
  transform: translate(-100%,0);
  height: 100%;
  overflow-y: auto;
}
.mobile-aside {
  width: 260px;
  background-color: #fff;
  bottom: 0;
  -webkit-transition: all 0.4s ease;
  -moz-transition: all 0.4s ease;
  transition: all 0.4s ease;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.1);
}

.sidebar-menu ul {
  font-size: 14px;
  list-style-type: none;
}

.sidebar-menu > ul > li > a {
  padding: 10px
}

.sidebar-menu li a {
  color: #888;
  display: block;
  font-size: 18px;
  min-height: 40px;
  padding: 0 20px;
}

.sidebar-menu li a:hover {
  color: var(--main-color);
}

.sidebar-menu li.active a {
  color: var(--main-color);
  background-color: #f3f3f3;
}
.close-btn{
  top: .25rem;
  right: .25rem;
}
.close-btn span{
  font-size: 26px;
  text-shadow: 0 0 3px #888
}
.close-btn span:hover{
  text-shadow: 0 0 1px #888
}

</style>
